import Vue from 'vue';
import Vuex from 'vuex';
import { ErrorStore } from '@/stores/error.store';
import CategoryStore from '@/stores/product/category.store';
import UserStore from '@/stores/user/user.store';
import KeycloakStore from '@/stores/user/keycloak.store';
import SearchBarStore from '@/stores/search/searchBar.store';
import SearchResultStore from '@/stores/search/searchResult.store';
import AddressStore from '@/stores/user/address.store';
import BrowseStore from '@/stores/product/browse.store';
import OrderStore from '@/stores/order/order.store';
import { ProductDetailStore } from '@/stores/product/product-detail.store';
import ShopStore from '@/stores/shop.store';
import MegacardStore from '@/stores/user/megacard.store';
import { CmsStore } from '@/stores/cms.store';
import OrderHistoryStore from '@/stores/order/order-history.store';
import { vuexPersistLocalStorage } from '@/stores/vuex-persist-config';
import PaymentStore from '@/stores/order/payment.store';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    ErrorStore,
    AddressStore,
    BrowseStore,
    CategoryStore,
    KeycloakStore,
    UserStore,
    OrderStore,
    ProductDetailStore,
    SearchBarStore,
    SearchResultStore,
    ShopStore,
    MegacardStore,
    OrderHistoryStore,
    CmsStore,
    PaymentStore,
  },
  plugins: [vuexPersistLocalStorage.plugin],
});

export default store;
